// Applied before React mounts; the supplied source archive has no HTML template.
export function configureDocumentLanguage(doc = document) {
  doc.documentElement.lang = 'ru';
  doc.documentElement.setAttribute('translate', 'no');
  doc.documentElement.classList.add('notranslate');
  const root = doc.getElementById('root');
  if (root) root.setAttribute('translate', 'no');
  for (const [selector, attributes] of [
    ['meta[name="google"]', { name: 'google', content: 'notranslate' }],
    ['meta[http-equiv="Content-Language"]', { 'http-equiv': 'Content-Language', content: 'ru' }],
  ]) {
    const meta = doc.querySelector(selector) || doc.createElement('meta');
    Object.entries(attributes).forEach(([key, value]) => meta.setAttribute(key, value));
    if (!meta.parentNode) doc.head.appendChild(meta);
  }
}

if (typeof document !== 'undefined') configureDocumentLanguage();
